export default __webpack_public_path__ + "static/media/mastercard.463a01d6.svg";